import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@15.5.12_@babel+core@7.29.0_@opentelemetry+api@1.9.1_babel-plugin-react-compiler@1._6721e8e1c570eb0533c207e3c57f8f11/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/tracked-lead-link.tsx");
